<template lang="pug">
v-expansion-panel.elevation-0
  v-expansion-panel-content
    v-layout(align-center, slot='header')
      span Calculator

    v-card.pa-4
      p Zet deze regels in de
        =" "
        code #{'<'}head#{'>'}
        =" "
        | van je website:
      pre {{ calculatorEmbedUrl }}

      p.mt-4 En zet onderstaande code op de plek waar je de berekentool wil tonen:
      pre {{ businessLeaseCalculatorCode }}

      p.mt-2 Eventueel kan je hier meer velden aan toevoegen. Zie de tabel onderaan de pagina.

      p.mt-4 Hieronder zie je de standaard opmaak van de berekentool. Eventueel kan je de tool een eigen stijl geven door zelf CSS toe te passen.

      v-layout(align-center, column)
        v-card.pa-4
          v-layout.embed-example(column, align-end)
            img(src='/images/embed_example.png')
            span Calculator voorbeeld
</template>

<script>
export default {
  props: {
    domain: String,
    isBusinessLease: Boolean
  },

  computed: {
    businessLeaseCalculatorCode () {
      return `<div id="dfs-lce" data-domain="${this.domain}" data-leasetype="${(this.isBusinessLease ? 'zakelijk' : 'particulier')}"></div>`
    },

    /* eslint-disable */
    calculatorEmbedUrl () {
      return `<script async src="https://embed.dealerfinanceservices.nl/lease-calculator.js"><\/script>
<link href="https://embed.dealerfinanceservices.nl/lease-calculator.css" rel="stylesheet">
<link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet">`
    }
    /* eslint-enable */
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

pre {
  background: $gray6;
  padding: 10px 15px;
  font-size: 12px;
}

.embed-example {
  cursor: not-allowed;

  img {
    max-width: 60vw;
  }
}
</style>
